import { _ } from "../../../../core/polyglot/polyglot.js";
import AbstractPredictionRuleModel from "./AbstractPredictionRuleModel.js";

/**
 * Compute data using machine learning.
 *
 * @param {number} shift - Number of previous months
 *   to consider for the regression
 */
export default class SingularSpectrumAnalysisRuleModel extends AbstractPredictionRuleModel {
	constructor({ shift = 12 } = {}) {
		super(...arguments);

		this._shift = shift;
	}

	getShift() {
		return this._shift;
	}

	setShift(shift) {
		this._shift = shift;
	}

	accept(visitor) {
		return visitor.visitSingularSpectrumAnalysisRuleModel(this);
	}

	_serializedProperties() {
		const properties = super._serializedProperties();

		properties.shift = this._shift;

		return properties;
	}

	static getLabel() {
		return _("Singular Spectrum Analysis");
	}

	static getType() {
		return "SmartPrediction";
	}

	static getDescriptionText() {
		return _(
			"Forecast based on a decomposition of the time-series in multiple components. See {wikipediaLink}",
			{
				wikipediaLink: (html) =>
					html.a(
						{
							target: "_blank",
							href: "https://en.wikipedia.org/wiki/Singular_spectrum_analysis",
							click: (event) => event.stopPropagation(),
						},
						"wikipedia",
					),
			},
		);
	}
}
